module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAU9JREFUOE+tkzFLA0EQhd/bOz1LixTxIIfpLAUbCwsDghY2YpMDBS0sxMIfIBIs/AliYZFCIQkIImgnxNLOFBY2cpqDi0UKO02425EYE0jkuBRusywz38yb3bfE76r4jYJo2eqd43YhLlzHPuzE2Usq14OqFn1NLbVYUHFWUe3nHTv7B5YoOnKzmfs4uOT5izSMYh+u+MG6iKxCuCJEjZD32M5gmsACIJckb1iuB55oOYGSZtK8/bhmiop7XThijmOyHH7qW9My54D2S95xnuLlN6ZpSPV/YDc79Tqq7JI31NkYNy0Jw/mkAjTNh6gdtgZlG3IGQQrER2wBwSSIpkTcGYaLI75zQSJud+G34BGULwhmROu1RJModQXiGcIJFj0vbSlricABdLSbBEMZpwIct3TrbsDbo8rOO3ZuwNslPzinYCPptn9+Vcbe7OR9A+kmzrGS0ty8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fax.png
// module id = weUC
// module chunks = 13